import { BRANDS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/brands_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'brandsIndex',
	'poBrandsIndex',
	'locationsAdvancedFilters',
	'analyticsAdvancedFilters',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
